/** @jsx jsx */
import { Box, Container, Heading, jsx, Text } from 'theme-ui'

const ReviewListSectionHeading = ({ bgOverride, subtitle, title }) => {
  return (
    <Box bg={bgOverride || 'backgroundMedium'}>
      <Container pt={[3, 7, 9]} pb={[5, 6, 7]} sx={{ textAlign: 'center' }}>
        <Heading as="h2" variant="title2" mb={[3, 4]}>
          {title}
        </Heading>
        <Text as="p" m="0" variant="body1" sx={{ fontWeight: 'bold' }}>
          {subtitle}
        </Text>
      </Container>
    </Box>
  )
}

export default ReviewListSectionHeading
